(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ontario-park-selector"] && !window.DesignMode) return;
  try {
    
  let parks = {
    'Algonquin' : 'Algonquin Provincial Park',
    'Arrowhead' : 'Arrowhead Provincial Park',
    'BonEcho' : 'Bon Echo Provincial Park',
    'BrucePeninsula' : 'Bruce Peninsula National Park',
    'Elora' : 'Elora',
    'Emily' : 'Emily Provincial Park',
    'Huntsville' : 'Huntsville',
    'Kawartha' : 'Kawartha Highlands Provincial Park',
    'Killarney' : 'Killarney Provincial Park',
    'Killbear' : 'Killbear Provincial Park',
    'Longpoint' : 'Long Point Provincial Park',
    'MonoCliffs' : 'Mono Cliffs Provincial Park',
    'Muskoka' : 'Muskoka',
    'Niagara' : 'Niagara Falls',
    'Pinery' : 'Pinery Provincial Park',
    'PointPelee' : 'Point Pelee National Park',
    'Presquile' : 'Presqu\'ile Provincial Park',
    'Sandbanks' : 'Sandbanks Provincial Park',
    'SilentLake' : 'Silent Lake Provincial Park',
    'Temagami' : 'Temagami Provincial Park',
    'ThousandIsland' : 'Thousand Island National Park',
    'LakeSuperior' : 'Lake Superior Provincial Park',
    'Pukaskwa' : 'Pukaskwa National Park',
    'SleepingGiant' : 'Sleeping Giant Provincial Park',
    'Bonnechere' : 'Bonnechere Provincial Park',
    'FrenchRiver' : 'French River Provincial Park',
    'PancakeBay' : 'Pancake Bay Provincial Park',
    'BronteCreek' : 'Bronte Creek Provincial Park',
    'EarlRowe' : 'Earl Rowe Provincial Park',
    'ForksOfTheCredit' : 'Forks Of The Credit Provincial Park',
    'Inverhuron' : 'Inverhuron Provincial Park',
    'Rondeau' : 'Rondeau Provincial Park',
    'GrundyLake' : 'Grundy Lake Provincial Park'
  }
  let selector = $('#park-selector');
  $.each(parks, function (i, item) {
    selector.append($('<option>', { 
        value: '/collections/all/'+i,
        text : item 
    }));
  });
  selector.on('change', function(){
    // console.log(a);
    let link = '';
    $("select#park-selector option:selected").each(function() {
      link = $(this).val();
    });
    if(link.length > 0) {
      document.location.href = link;
    }
  })

  } catch(e) { console.error(e); }
})();

})();
